import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import Util from '../util/Util';

class ReportController {

  static getOptions = (field, isActive) => {
    
    const type = field.field_type;
    let options = [];
    if(type.includes(Const.Opt + 'product')) {
      options = reactLocalStorage.getObject(Const.Products);
    } else if(type.includes(Const.Opt) && type.includes(Const.Select)) {
      const splitField = field.field_type.split(Const.Opt);
      const modelName = splitField[1];
      const models = reactLocalStorage.getObject(Const.Model);
      if(!models[modelName]) options = [];
      else if(splitField.length === 2) options = models[modelName].options;
      else if(splitField.length === 3) {
        if(!models[modelName].fields[splitField[2]]) options = [];
        options = models[modelName].fields[splitField[2]].options;
      }
    } else if(field.field_type === Const.City) {
      options = reactLocalStorage.getObject(Const.Cities);
    } else if(field.field_type === Const.State) {
      options = reactLocalStorage.getObject(Const.States);
    } else if(field.field_type === Const.Country) {
      options = reactLocalStorage.getObject(Const.Countries);
    } else if(field.field_type === Const.Complete) { 
      options = [ {label: 'Yes', value: 1}, {label: 'No', value: 0} ];
    } else if(field.options) {
      options = field.options;
    }

    if(isActive) { 
      options = options.filter(option => option.status && option.status === 1); 
    }
    
    return options;
  }

  static getHeaderDate = (filters, field) => {
    let options = [];
    const filter = filters ? filters.find(filter => filter.field === field.field_key) : null;
    if(filter) {
      const dates = filter.value.split(Const.Opt);
      let from = Util.serverStringDateTimeToDate(dates[0]);
      const to = Util.serverStringDateTimeToDate(dates[1]);
      while(from < to) {
        from.setHours(0);
        from.setMinutes(0);
        let value = Util.dateToServerDateTime(from);
        from.setHours(23);
        from.setMinutes(59);
        value += Const.Opt + Util.dateToServerDateTime(from);
        options.push({label: Util.dateToDisplayDate(from), value });
        
        from.setHours(0);
        from.setMinutes(0);
        from.setDate(from.getDate() + 1);
      }
    }
    return options;
  }

  static getHeaderMonth = (filters, field) => {
    let options = [];
    const filter = filters ? filters.find(filter => filter.field === field.field_key) : null;
    if(filter) {
      const dates = filter.value.split(Const.Opt);
      let from = Util.serverStringDateTimeToDate(dates[0]);
      const to = Util.serverStringDateTimeToDate(dates[1]);
      while(from < to) {
        from.setHours(0);
        from.setMinutes(0);
        let value = Util.dateToServerDateTime(from);
        
        from = new Date(from.getFullYear(), from.getMonth() + 1, 0);
        from.setHours(23);
        from.setMinutes(59);
        value += Const.Opt + Util.dateToServerDateTime(from);
        options.push({label: Util.dateToDisplayMonth(from), value });
        
        from.setHours(0);
        from.setMinutes(0);
        from.setDate(from.getDate() + 1);
      }
    }
    return options;
  }

  static getHeaderDay = (filters, field) => {
    let options = [];
    const filter = filters ? filters.find(filter => filter.field === field.field_key) : null;
    if(filter) {
      const dates = filter.value.split(Const.Opt);
      let from = Util.serverStringDateTimeToDate(dates[0]);
      const to = Util.serverStringDateTimeToDate(dates[1]);
      from.setDate(from.getDate() - 1);
      while(from < to) {
        from.setDate(from.getDate() + 1);
        from.setHours(0);
        from.setMinutes(0);
        from.setSeconds(0);
        let value = Util.dateToServerDateTime(from);
        
        from.setHours(23);
        from.setMinutes(59);
        from.setSeconds(59);
        value += Const.Opt + Util.dateToServerDateTime(from);
        options.push({label: Util.dateToDisplayDay(from), value });
      }
    }
    return options;
  }

  static getHeaderHrs = (filters, field) => {
    let options = [];
    const filter = filters ? filters.find(filter => filter.field === field.field_key) : null;
    if(filter) {
      const dates = filter.value.split(Const.Opt);
      let from = Util.serverStringDateTimeToDate(dates[0]);
      from.setHours(9);
      from.setMinutes(0);
      from.setSeconds(0);
      from.setMilliseconds(0);
      const to = Util.serverStringDateTimeToDate(dates[1]);
      to.setHours(20);
      to.setMinutes(59);
      to.setMinutes(59);
      to.setMilliseconds(999);
      while(from < to) {
        let value = Util.dateToServerDateTime(from);
        let label = Util.dateToDisplayHr(from);
        from.setTime(from.getTime() + (60 * 60 * 1000) - 1);
        value += Const.Opt + Util.dateToServerDateTime(from);
        from.setTime(from.getTime() + 1);
        label += ` ${Const.Hhn} ${Util.dateToDisplayHr(from)}`;
        from.setTime(from.getTime() - 1);
        options.push({ label, value });
        from.setTime(from.getTime() + 1);
      }
    }
    return options;
  }

  static isIn = (FromTo, value) => {
    const dates = FromTo.split(Const.Opt);
    const from = Util.dateToServerDateTime(dates[0]);
    const to = Util.dateToServerDateTime(dates[1]);
    const date = Util.dateToServerDateTime(value);
    return from <= date && date <= to;
  }

  static time = secs => {
    let tmp = '';
    const hrs = Math.floor(secs / 3600) % 24;
    if(hrs > 0) { 
      secs -= hrs * 3600; 
      tmp = hrs + 'h';
    }

    const mins = Math.floor(secs / 60) % 60;
    if(mins > 0) {
      secs -= mins * 60;
      tmp += tmp !== '' ? ' ' + mins + 'm' : mins + 'm';
    }
    if(secs > 0) {
      tmp += tmp !== '' ? ' ' + secs + 's' : secs + 's';
    }
    return tmp !== '' ? `(${tmp})` : '(0s)';
  }
}
export default ReportController;